import { render, staticRenderFns } from "./FormNavigation.vue?vue&type=template&id=12047abe&"
import script from "./FormNavigation.vue?vue&type=script&lang=js&"
export * from "./FormNavigation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports